import {Pageable} from '../../../../../../shared/model/core/pageable.model';
import {UrlParameter} from '../../../../../../shared/utils/url.builder';
import {QueryParams} from '@ngrx/data';
import {Page} from '../../../../../../shared/model/core/page.model';
import {Observable} from 'rxjs';
import {AbstractDataServiceAdapter} from '../../dataservice/adapter/abstractDataService.adapter';

export class PaginatedServiceUtils {

    public static buildQueryParams(pageable: Pageable, parameters: UrlParameter[]): QueryParams {
        // // console.logByType['parameters', parameters]);
        const queryParams = {};
        if (pageable) {
            queryParams['page'] = pageable.pageNumber;
            queryParams['size'] = pageable.pageSize;
            if (pageable.sort) {
                queryParams['sortBy'] = pageable.sort._name + ':' + pageable.sort._order;
            }
        }

        if (parameters) {
            parameters.forEach(urlParameter => queryParams[urlParameter._name] = encodeURIComponent(urlParameter.valueParameter()));
        }
        return queryParams;
    }

    public static findPaginated<Entity>(dataService: AbstractDataServiceAdapter<any, Entity, any>,
                                        fullPath: string, pageable: Pageable,
                                        parameters: UrlParameter[],
                                        additionalParameters: UrlParameter[]): Observable<Page<Entity>> {
        const httpParameters: UrlParameter[] = [];
        parameters?.forEach(value => httpParameters.push(value));
        additionalParameters?.forEach(value => httpParameters.push(value));
        return dataService.getMultipleWithQuery(fullPath, PaginatedServiceUtils.buildQueryParams(pageable, httpParameters));

    }
}
